import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { NewsAndGuidesDisableMode } from '#src/app/pages/newsAndGuides/shared/utils';
import { redirectToPetitionGuidesIfDisabled } from '#src/app/pages/newsAndGuides/shared/utils';

import type { NewsAndGuidesListDataQuery, NewsAndGuidesListDataQueryVariables } from './api.graphql';
import { NewsAndGuidesListData } from './api.graphql';
import { NewsAndGuidesListPageDataError } from './types';

export type NewsAndGuidesListPageData = {
	hasGuides: boolean;
	countryCode: string;
	guides: boolean;
};

export async function getNewsAndGuidesListPageData(
	{ gql: { fetch } }: UtilityContext,
	{
		countryCode,
		locale,
		guides,
		disableMode,
	}: { countryCode: string; locale: string; guides: boolean; disableMode: NewsAndGuidesDisableMode },
): Promise<NewsAndGuidesListPageData> {
	// Country-disable check runs first: the FCM-driven redirect takes priority and avoids a needless fetch.
	redirectToPetitionGuidesIfDisabled(disableMode);

	const { data } = await fetch<NewsAndGuidesListDataQuery, NewsAndGuidesListDataQueryVariables>({
		query: NewsAndGuidesListData,
		variables: {
			countryCode,
			locale,
		},
		rejectOnError: false,
	});

	if (!data?.hasGuides && guides) {
		// Cannot use RedirectError here for now because it does not support forceExternal mode
		throw new NewsAndGuidesListPageDataError('news_and_guides_list_page_data_no_guides');
	}

	return { hasGuides: !!data?.hasGuides, countryCode, guides };
}
